import React from "react";
import {
  Box,
  MainCard,
  MainText,
  PressableOpacity,
} from "app/components/common";
import { Linking } from "react-native";
import { getSurveyRequest } from "@microdoing/shared/services/survey/actions";
import { useNavigation } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import i18n from "@microdoing/shared/i18n";

interface IProps {
  iconBox: React.ReactElement;
  time: string;
  title: string;
  url: string;
  surveyId: string;
}

export const UnlockedTimelineCard = ({
  iconBox,
  time,
  title,
  url,
  surveyId,
}: IProps) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const redirectUrl = () => {
    Linking.openURL(url);
  };

  const redirectSurvey = () => {
    dispatch(getSurveyRequest({ surveyId: surveyId }));
    navigation.navigate("Survey", { isComingFromSignup: false });
  };

  const handlePressCard = () => {
    url ? redirectUrl() : redirectSurvey();
  };

  return (
    <PressableOpacity onPress={handlePressCard}>
      <MainCard
        variant="timelineCard"
        flexDirection="row"
        backgroundColor="neutral.50"
        borderColor="gradient.blueGradient.start"
        borderWidth={2}
        strokePosition="outside"
      >
        {iconBox}
        <Box flex={1} marginLeft="sm">
          <MainText
            numberOfLines={1}
            variant="l4-bold"
            color="gradient.blueGradient.start"
          >
            {title}
          </MainText>
          <MainText
            numberOfLines={1}
            variant="l3-medium"
            color="neutral.600"
            marginTop={4}
          >
            {i18n.t("click-here-to-access-it")}
          </MainText>
        </Box>
        <MainText variant="l3-bold" color="gradient.blueGradient.start">
          {time}
        </MainText>
      </MainCard>
    </PressableOpacity>
  );
};
